export const lightTheme = {
  // Fonts
  fonts: {
    primary: "Quicksand, sans-serif",
    secondary: "Poppins, sans-serif",
  },

  // Colors
  colors: {
    primary: "#F1F1F1",
    secondary: "#FFFFFF",
    blue: "#004797",
    red: "#E72142",
    white: "#FFFFFF",
    yellow: "#FCC000",
    text: "#316B83",
    link: "#004797",
    title: "linear-gradient(45deg, #e72142, #004797)",
    header:
      "rgba(0, 71, 151, 1) 0%, rgba(0, 71, 151, 1) 48%, rgba(0, 23, 151, 1) 100%",
    banner: "rgba(233, 162, 188, 0.1) 45%,rgba(233, 162, 188, 0.1) 45%",
  },

  // Backgrounds
  backgrounds: {
    Background: "rose-petals.svg",
    headBackground: "flat-mountains.svg",
  },
}

export const darkTheme = {
  // Fonts
  fonts: {
    primary: "Quicksand, sans-serif",
    secondary: "Poppins, sans-serif",
  },

  // Colors
  colors: {
    primary: "#15202b",
    secondary: "#192734",
    blue: "#1a8cd8",
    red: "#f91880",
    yellow: "#57bb5c",
    white: "#FFFFFF",
    text: "#FFFFFF",
    link: "#1d9bf0",
    title: "linear-gradient(45deg, #f1f1f1c7, #F1F1F1)",
    header: "rgba(25,39,52,1) 0%, rgba(25,39,52,1) 100%",
    banner: "rgba(25, 39, 52, 1) 45%, rgba(25, 39, 52, 1) 45%",
  },

  // Backgrounds
  backgrounds: {
    Background: "rose-petals-dark.svg",
    headBackground: "flat-mountains-dark.svg",
  },
}
